import {PositionParent} from 'common/components/drop-menu';
import {ButtonOption} from 'common/components/popover-card/types';

export enum VIEWS {
  CREATE_COHORT = `create-cohort`,
  BREAKDOWN = `breakdown`,
  POPOVER = `popover`,
}

export type ActionsPopoverState = {
  dropMenuOpen: boolean;
  keydownProxyEl: HTMLElement;
  searchFilter: string;
  view: VIEWS;
  positionParent?: PositionParent;
};
export type ActionsPopoverAttrs = {
  open?: boolean;
  'is-segmented'?: boolean;
  title?: string;
  subtitle?: string;
  'button-options'?: ButtonOption[];
  'breakdown-options'?: TODO;
  event?: string;
  'project-id'?: number;
  'workspace-id'?: number;
  'prevent-close-selectors'?: string[];
};

export type ActionsPopoverProps = {
  attrs?: ActionsPopoverAttrs;
  on?: {
    action?: (ev: CustomEvent<{action: any}>) => void;
    close?: () => void;
  };
  props?: {
    positionParent?: PositionParent;
  };
};
